<template>
    <div>404</div>
</template>
<script>
export default {
    name: "page404"
}
</script>
